<tt-page *ngIf="!!setting">
    <div *ngIf="'mobile' | mediaQuery">
        <tt-card class="col-xs-12 p-5">
            <tt-button-goto ttText="orderpurchmenu_new" ttGoto="orderpurch" [ttGotoParms]="{ order_internal_no: setting.order_internal_no }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list-legacy class="col-xs-12 p-5" [listItems]="itemsListPurchaseHeads" ltype="multi" typevar="g"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="orderpurchmenu_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="80">
                    <tt-list-legacy [listItems]="itemsListPurchaseHeads" ltype="multi" typevar="g"></tt-list-legacy>
                </tt-divider-pane>

                <tt-divider-pane ttSize="20">
                    <tt-card>
                        <tt-button-goto ttText="orderpurchmenu_new" ttGoto="orderpurch" [ttGotoParms]="{ order_internal_no: setting.order_internal_no }" ttIcon="far fa-plus"></tt-button-goto>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
